var _CUSTOM_COD_FORM_PROVINCES = {
  data: {
  "Aguascalientes": {
    "Aguascalientes": {
      "20000": true,
      "20010": true,
      "20016": true,
      "20018": true,
      "20020": true,
      "20029": true,
      "20030": true,
      "20040": true,
      "20049": true,
      "20050": true,
      "20059": true,
      "20060": true,
      "20064": true,
      "20070": true,
      "20078": true,
      "20080": true,
      "20089": true,
      "20100": true,
      "20110": true,
      "20115": true,
      "20116": true,
      "20118": true,
      "20119": true,
      "20120": true,
      "20123": true,
      "20124": true,
      "20126": true,
      "20127": true,
      "20129": true,
      "20130": true,
      "20135": true,
      "20136": true,
      "20137": true,
      "20138": true,
      "20140": true,
      "20146": true,
      "20149": true,
      "20150": true,
      "20157": true,
      "20158": true,
      "20159": true,
      "20160": true,
      "20164": true,
      "20169": true,
      "20170": true,
      "20172": true,
      "20174": true,
      "20175": true,
      "20177": true,
      "20179": true,
      "20180": true,
      "20190": true,
      "20196": true,
      "20198": true,
      "20199": true,
      "20205": true,
      "20206": true,
      "20207": true,
      "20208": true,
      "20210": true,
      "20217": true,
      "20218": true,
      "20219": true,
      "20220": true,
      "20229": true,
      "20230": true,
      "20234": true,
      "20235": true,
      "20236": true,
      "20237": true,
      "20238": true,
      "20239": true,
      "20240": true,
      "20247": true,
      "20248": true,
      "20249": true,
      "20250": true,
      "20255": true,
      "20256": true,
      "20257": true,
      "20259": true,
      "20260": true,
      "20263": true,
      "20264": true,
      "20265": true,
      "20266": true,
      "20267": true,
      "20268": true,
      "20269": true,
      "20270": true,
      "20276": true,
      "20277": true,
      "20278": true,
      "20280": true,
      "20284": true,
      "20285": true,
      "20286": true,
      "20287": true,
      "20288": true,
      "20289": true,
      "20296": true,
      "20297": true,
      "20326": true,
      "20328": true,
      "20329": true
    },
    "Jesús María": {
      "20900": true,
      "20905": true,
      "20907": true,
      "20908": true,
      "20920": true,
      "20922": true,
      "20923": true,
      "20924": true,
      "20925": true,
      "20926": true,
      "20927": true,
      "20983": true,
      "20984": true
    }
  },
  "Ciudad de México": {
    "Álvaro Obregón": {
      "1000": true,
      "1010": true,
      "1020": true,
      "1030": true,
      "1040": true,
      "1049": true,
      "1050": true,
      "1060": true,
      "1070": true,
      "1080": true,
      "1089": true,
      "1090": true,
      "1100": true,
      "1109": true,
      "1110": true,
      "1120": true,
      "1125": true,
      "1130": true,
      "1139": true,
      "1140": true,
      "1150": true,
      "1160": true,
      "1170": true,
      "1180": true,
      "1200": true,
      "1210": true,
      "1219": true,
      "1220": true,
      "1230": true,
      "1239": true,
      "1240": true,
      "1250": true,
      "1259": true,
      "1260": true,
      "1269": true,
      "1270": true,
      "1275": true,
      "1276": true,
      "1278": true,
      "1279": true,
      "1280": true,
      "1285": true,
      "1289": true,
      "1290": true,
      "1296": true,
      "1298": true,
      "1299": true,
      "1310": true,
      "1320": true,
      "1330": true,
      "1340": true,
      "1376": true,
      "1377": true,
      "1389": true,
      "1400": true,
      "1407": true,
      "1408": true,
      "1410": true,
      "1419": true,
      "1420": true,
      "1430": true,
      "1450": true,
      "1460": true,
      "1470": true,
      "1480": true,
      "1490": true,
      "1500": true,
      "1509": true,
      "1510": true,
      "1520": true,
      "1530": true,
      "1538": true,
      "1539": true,
      "1540": true,
      "1548": true,
      "1549": true,
      "1550": true,
      "1560": true,
      "1566": true,
      "1569": true,
      "1588": true,
      "1590": true,
      "1600": true,
      "1610": true,
      "1618": true,
      "1619": true,
      "1620": true,
      "1630": true,
      "1640": true,
      "1645": true,
      "1650": true,
      "1700": true,
      "1708": true,
      "1710": true,
      "1720": true,
      "1729": true,
      "1730": true,
      "1740": true,
      "1750": true,
      "1759": true,
      "1760": true,
      "1770": true,
      "1780": true,
      "1789": true,
      "1790": true,
      "1800": true,
      "1807": true,
      "1810": true,
      "1820": true,
      "1830": true,
      "1840": true,
      "1849": true,
      "1857": true,
      "1859": true,
      "1860": true,
      "1863": true,
      "1870": true,
      "1900": true,
      "1904": true
    },
    "Azcapotzalco": {
      "2000": true,
      "2010": true,
      "2020": true,
      "2040": true,
      "2050": true,
      "2060": true,
      "2070": true,
      "2080": true,
      "2090": true,
      "2099": true,
      "2100": true,
      "2120": true,
      "2128": true,
      "2129": true,
      "2130": true,
      "2140": true,
      "2150": true,
      "2160": true,
      "2200": true,
      "2230": true,
      "2240": true,
      "2250": true,
      "2300": true,
      "2310": true,
      "2320": true,
      "2330": true,
      "2340": true,
      "2360": true,
      "2400": true,
      "2410": true,
      "2420": true,
      "2440": true,
      "2459": true,
      "2460": true,
      "2470": true,
      "2480": true,
      "2490": true,
      "2500": true,
      "2519": true,
      "2520": true,
      "2530": true,
      "2600": true,
      "2630": true,
      "2640": true,
      "2650": true,
      "2660": true,
      "2670": true,
      "2680": true,
      "2700": true,
      "2710": true,
      "2719": true,
      "2720": true,
      "2730": true,
      "2750": true,
      "2760": true,
      "2770": true,
      "2780": true,
      "2790": true,
      "2800": true,
      "2810": true,
      "2830": true,
      "2840": true,
      "2860": true,
      "2870": true,
      "2900": true,
      "2910": true,
      "2920": true,
      "2930": true,
      "2940": true,
      "2950": true,
      "2960": true,
      "2970": true,
      "2980": true,
      "2990": true
    },
    "Benito Juárez": {
      "3000": true,
      "3010": true,
      "3020": true,
      "3023": true,
      "3100": true,
      "3103": true,
      "3104": true,
      "3200": true,
      "3230": true,
      "3240": true,
      "3300": true,
      "3303": true,
      "3310": true,
      "3320": true,
      "3330": true,
      "3340": true,
      "3400": true,
      "3410": true,
      "3420": true,
      "3430": true,
      "3440": true,
      "3500": true,
      "3510": true,
      "3520": true,
      "3530": true,
      "3540": true,
      "3550": true,
      "3560": true,
      "3570": true,
      "3580": true,
      "3590": true,
      "3600": true,
      "3610": true,
      "3620": true,
      "3630": true,
      "3640": true,
      "3650": true,
      "3660": true,
      "3700": true,
      "3710": true,
      "3720": true,
      "3730": true,
      "3740": true,
      "3800": true,
      "3810": true,
      "3820": true,
      "3840": true,
      "3900": true,
      "3910": true,
      "3920": true,
      "3930": true,
      "3940": true
    },
    "Coyoacán": {
      "4000": true,
      "4010": true,
      "4020": true,
      "4030": true,
      "4040": true,
      "4100": true,
      "4120": true,
      "4200": true,
      "4210": true,
      "4230": true,
      "4240": true,
      "4250": true,
      "4260": true,
      "4300": true,
      "4310": true,
      "4318": true,
      "4320": true,
      "4330": true,
      "4340": true,
      "4360": true,
      "4369": true,
      "4370": true,
      "4380": true,
      "4390": true,
      "4400": true,
      "4410": true,
      "4420": true,
      "4440": true,
      "4450": true,
      "4460": true,
      "4470": true,
      "4480": true,
      "4489": true,
      "4490": true,
      "4500": true,
      "4510": true,
      "4519": true,
      "4530": true,
      "4600": true,
      "4610": true,
      "4620": true,
      "4630": true,
      "4640": true,
      "4650": true,
      "4660": true,
      "4700": true,
      "4710": true,
      "4730": true,
      "4739": true,
      "4800": true,
      "4810": true,
      "4815": true,
      "4830": true,
      "4840": true,
      "4870": true,
      "4890": true,
      "4899": true,
      "4909": true,
      "4910": true,
      "4918": true,
      "4919": true,
      "4920": true,
      "4929": true,
      "4930": true,
      "4938": true,
      "4939": true,
      "4940": true,
      "4950": true,
      "4960": true,
      "4970": true,
      "4980": true
    },
    "Cuauhtémoc": {
      "6000": true,
      "6010": true,
      "6020": true,
      "6030": true,
      "6040": true,
      "6050": true,
      "6060": true,
      "6070": true,
      "6080": true,
      "6090": true,
      "6100": true,
      "6140": true,
      "6170": true,
      "6200": true,
      "6220": true,
      "6240": true,
      "6250": true,
      "6270": true,
      "6280": true,
      "6300": true,
      "6350": true,
      "6400": true,
      "6430": true,
      "6450": true,
      "6470": true,
      "6500": true,
      "6600": true,
      "6700": true,
      "6720": true,
      "6760": true,
      "6780": true,
      "6800": true,
      "6820": true,
      "6840": true,
      "6850": true,
      "6860": true,
      "6870": true,
      "6880": true,
      "6890": true,
      "6900": true,
      "6920": true
    },
    "Iztacalco": {
      "8000": true,
      "8010": true,
      "8020": true,
      "8030": true,
      "8040": true,
      "8100": true,
      "8200": true,
      "8210": true,
      "8220": true,
      "8230": true,
      "8240": true,
      "8300": true,
      "8310": true,
      "8320": true,
      "8400": true,
      "8420": true,
      "8500": true,
      "8510": true,
      "8600": true,
      "8610": true,
      "8620": true,
      "8650": true,
      "8700": true,
      "8710": true,
      "8720": true,
      "8730": true,
      "8760": true,
      "8770": true,
      "8800": true,
      "8810": true,
      "8830": true,
      "8840": true,
      "8900": true,
      "8910": true,
      "8920": true,
      "8930": true
    },
    "Gustavo A. Madero": {
      "7000": true,
      "7010": true,
      "7020": true,
      "7040": true,
      "7050": true,
      "7058": true,
      "7060": true,
      "7069": true,
      "7070": true,
      "7080": true,
      "7089": true,
      "7090": true,
      "7100": true,
      "7109": true,
      "7110": true,
      "7119": true,
      "7130": true,
      "7140": true,
      "7144": true,
      "7149": true,
      "7150": true,
      "7160": true,
      "7164": true,
      "7170": true,
      "7180": true,
      "7183": true,
      "7187": true,
      "7188": true,
      "7189": true,
      "7190": true,
      "7199": true,
      "7200": true,
      "7207": true,
      "7209": true,
      "7210": true,
      "7214": true,
      "7220": true,
      "7224": true,
      "7230": true,
      "7239": true,
      "7240": true,
      "7250": true,
      "7259": true,
      "7268": true,
      "7270": true,
      "7279": true,
      "7280": true,
      "7290": true,
      "7300": true,
      "7310": true,
      "7320": true,
      "7330": true,
      "7340": true,
      "7350": true,
      "7359": true,
      "7360": true,
      "7369": true,
      "7370": true,
      "7380": true,
      "7400": true,
      "7410": true,
      "7420": true,
      "7430": true,
      "7440": true,
      "7450": true,
      "7455": true,
      "7456": true,
      "7458": true,
      "7460": true,
      "7469": true,
      "7470": true,
      "7480": true,
      "7500": true,
      "7509": true,
      "7510": true,
      "7520": true,
      "7530": true,
      "7540": true,
      "7550": true,
      "7560": true,
      "7570": true,
      "7580": true,
      "7600": true,
      "7620": true,
      "7630": true,
      "7640": true,
      "7650": true,
      "7670": true,
      "7680": true,
      "7700": true,
      "7707": true,
      "7708": true,
      "7720": true,
      "7730": true,
      "7739": true,
      "7740": true,
      "7750": true,
      "7754": true,
      "7755": true,
      "7760": true,
      "7770": true,
      "7780": true,
      "7790": true,
      "7800": true,
      "7810": true,
      "7820": true,
      "7830": true,
      "7838": true,
      "7839": true,
      "7840": true,
      "7850": true,
      "7858": true,
      "7859": true,
      "7860": true,
      "7869": true,
      "7870": true,
      "7880": true,
      "7889": true,
      "7890": true,
      "7899": true,
      "7900": true,
      "7910": true,
      "7918": true,
      "7919": true,
      "7920": true,
      "7930": true,
      "7939": true,
      "7940": true,
      "7950": true,
      "7960": true,
      "7969": true,
      "7970": true,
      "7979": true,
      "7980": true,
      "7990": true
    },
    "Iztapalapa": {
      "9000": true,
      "9010": true,
      "9020": true,
      "9030": true,
      "9040": true,
      "9060": true,
      "9070": true,
      "9080": true,
      "9089": true,
      "9090": true,
      "9099": true,
      "9100": true,
      "9130": true,
      "9140": true,
      "9180": true,
      "9200": true,
      "9208": true,
      "9209": true,
      "9210": true,
      "9220": true,
      "9230": true,
      "9239": true,
      "9240": true,
      "9250": true,
      "9260": true,
      "9270": true,
      "9280": true,
      "9290": true,
      "9300": true,
      "9310": true,
      "9319": true,
      "9320": true,
      "9350": true,
      "9359": true,
      "9360": true,
      "9400": true,
      "9410": true,
      "9420": true,
      "9429": true,
      "9430": true,
      "9438": true,
      "9440": true,
      "9450": true,
      "9460": true,
      "9470": true,
      "9479": true,
      "9480": true,
      "9500": true,
      "9510": true,
      "9520": true,
      "9530": true,
      "9550": true,
      "9560": true,
      "9570": true,
      "9578": true,
      "9600": true,
      "9608": true,
      "9609": true,
      "9620": true,
      "9630": true,
      "9637": true,
      "9638": true,
      "9640": true,
      "9648": true,
      "9660": true,
      "9670": true,
      "9680": true,
      "9689": true,
      "9690": true,
      "9696": true,
      "9698": true,
      "9700": true,
      "9704": true,
      "9705": true,
      "9706": true,
      "9708": true,
      "9709": true,
      "9710": true,
      "9720": true,
      "9730": true,
      "9740": true,
      "9750": true,
      "9760": true,
      "9769": true,
      "9770": true,
      "9780": true,
      "9790": true,
      "9800": true,
      "9810": true,
      "9819": true,
      "9820": true,
      "9828": true,
      "9829": true,
      "9830": true,
      "9837": true,
      "9838": true,
      "9839": true,
      "9840": true,
      "9849": true,
      "9850": true,
      "9856": true,
      "9858": true,
      "9859": true,
      "9860": true,
      "9868": true,
      "9870": true,
      "9880": true,
      "9890": true,
      "9897": true,
      "9900": true,
      "9910": true,
      "9920": true,
      "9930": true,
      "9940": true,
      "9960": true,
      "9969": true,
      "9970": true
    },
    "La Magdalena Contreras": {
      "10000": true,
      "10010": true,
      "10020": true,
      "10130": true,
      "10200": true,
      "10300": true,
      "10320": true,
      "10330": true,
      "10340": true,
      "10350": true,
      "10360": true,
      "10368": true,
      "10369": true,
      "10370": true,
      "10378": true,
      "10379": true,
      "10380": true,
      "10400": true,
      "10500": true,
      "10580": true,
      "10600": true,
      "10610": true,
      "10620": true,
      "10630": true,
      "10640": true,
      "10660": true,
      "10700": true,
      "10710": true,
      "10800": true,
      "10810": true,
      "10820": true,
      "10830": true,
      "10840": true,
      "10900": true,
      "10910": true,
      "10920": true,
      "10926": true
    },
    "Miguel Hidalgo": {
      "11000": true,
      "11040": true,
      "11100": true,
      "11200": true,
      "11210": true,
      "11220": true,
      "11230": true,
      "11240": true,
      "11250": true,
      "11260": true,
      "11270": true,
      "11280": true,
      "11289": true,
      "11290": true,
      "11300": true,
      "11310": true,
      "11320": true,
      "11330": true,
      "11340": true,
      "11350": true,
      "11360": true,
      "11370": true,
      "11400": true,
      "11410": true,
      "11420": true,
      "11430": true,
      "11440": true,
      "11450": true,
      "11460": true,
      "11470": true,
      "11480": true,
      "11489": true,
      "11490": true,
      "11500": true,
      "11510": true,
      "11520": true,
      "11529": true,
      "11530": true,
      "11540": true,
      "11550": true,
      "11560": true,
      "11570": true,
      "11580": true,
      "11590": true,
      "11600": true,
      "11610": true,
      "11619": true,
      "11650": true,
      "11700": true,
      "11800": true,
      "11810": true,
      "11820": true,
      "11830": true,
      "11840": true,
      "11850": true,
      "11860": true,
      "11870": true,
      "11910": true,
      "11920": true,
      "11930": true,
      "11950": true
    },
    "Tlalpan": {
      "14000": true,
      "14010": true,
      "14020": true,
      "14030": true,
      "14039": true,
      "14040": true,
      "14049": true,
      "14050": true,
      "14060": true,
      "14070": true,
      "14080": true,
      "14090": true,
      "14100": true,
      "14108": true,
      "14110": true,
      "14120": true,
      "14140": true,
      "14150": true,
      "14160": true,
      "14200": true,
      "14208": true,
      "14209": true,
      "14210": true,
      "14219": true,
      "14220": true,
      "14230": true,
      "14239": true,
      "14240": true,
      "14248": true,
      "14250": true,
      "14260": true,
      "14266": true,
      "14267": true,
      "14268": true,
      "14269": true,
      "14270": true,
      "14275": true,
      "14300": true,
      "14308": true,
      "14310": true,
      "14320": true,
      "14325": true,
      "14326": true,
      "14330": true,
      "14340": true,
      "14350": true,
      "14357": true,
      "14360": true,
      "14370": true,
      "14376": true,
      "14377": true,
      "14380": true,
      "14386": true,
      "14387": true,
      "14388": true,
      "14389": true,
      "14390": true,
      "14400": true,
      "14406": true,
      "14408": true,
      "14409": true,
      "14410": true,
      "14420": true,
      "14426": true,
      "14427": true,
      "14429": true,
      "14430": true,
      "14438": true,
      "14439": true,
      "14440": true,
      "14449": true,
      "14460": true,
      "14470": true,
      "14476": true,
      "14479": true,
      "14480": true,
      "14490": true,
      "14500": true,
      "14600": true,
      "14608": true,
      "14609": true,
      "14610": true,
      "14620": true,
      "14629": true,
      "14630": true,
      "14640": true,
      "14643": true,
      "14646": true,
      "14647": true,
      "14650": true,
      "14653": true,
      "14655": true,
      "14657": true,
      "14658": true,
      "14659": true,
      "14700": true,
      "14710": true,
      "14720": true,
      "14730": true,
      "14734": true,
      "14735": true,
      "14737": true,
      "14738": true,
      "14739": true,
      "14740": true,
      "14748": true,
      "14749": true,
      "14760": true,
      "14900": true
    },
    "Venustiano Carranza": {
      "15000": true,
      "15010": true,
      "15020": true,
      "15100": true,
      "15200": true,
      "15210": true,
      "15220": true,
      "15230": true,
      "15240": true,
      "15250": true,
      "15260": true,
      "15270": true,
      "15280": true,
      "15290": true,
      "15300": true,
      "15309": true,
      "15310": true,
      "15320": true,
      "15330": true,
      "15339": true,
      "15340": true,
      "15350": true,
      "15370": true,
      "15380": true,
      "15390": true,
      "15400": true,
      "15410": true,
      "15420": true,
      "15430": true,
      "15440": true,
      "15450": true,
      "15460": true,
      "15470": true,
      "15500": true,
      "15510": true,
      "15520": true,
      "15530": true,
      "15540": true,
      "15600": true,
      "15610": true,
      "15620": true,
      "15630": true,
      "15640": true,
      "15650": true,
      "15660": true,
      "15670": true,
      "15680": true,
      "15700": true,
      "15710": true,
      "15730": true,
      "15740": true,
      "15750": true,
      "15800": true,
      "15810": true,
      "15820": true,
      "15830": true,
      "15840": true,
      "15850": true,
      "15860": true,
      "15870": true,
      "15900": true,
      "15960": true,
      "15970": true,
      "15980": true,
      "15990": true
    },
    "Xochimilco": {
      "16000": true,
      "16010": true,
      "16020": true,
      "16029": true,
      "16030": true,
      "16034": true,
      "16035": true,
      "16036": true,
      "16038": true,
      "16040": true,
      "16050": true,
      "16059": true,
      "16060": true,
      "16070": true,
      "16080": true,
      "16083": true,
      "16090": true,
      "16100": true,
      "16200": true,
      "16210": true,
      "16240": true,
      "16300": true,
      "16310": true,
      "16320": true,
      "16340": true,
      "16400": true,
      "16410": true,
      "16420": true,
      "16428": true,
      "16429": true,
      "16430": true,
      "16440": true,
      "16443": true,
      "16450": true,
      "16457": true,
      "16459": true,
      "16500": true,
      "16513": true,
      "16514": true,
      "16520": true,
      "16530": true,
      "16533": true,
      "16550": true,
      "16600": true,
      "16604": true,
      "16605": true,
      "16606": true,
      "16607": true,
      "16609": true,
      "16610": true,
      "16614": true,
      "16615": true,
      "16616": true,
      "16617": true,
      "16620": true,
      "16629": true,
      "16630": true,
      "16640": true,
      "16710": true,
      "16720": true,
      "16739": true,
      "16740": true,
      "16749": true,
      "16750": true,
      "16770": true,
      "16776": true,
      "16780": true,
      "16797": true,
      "16799": true,
      "16800": true,
      "16810": true,
      "16813": true,
      "16840": true,
      "16850": true,
      "16860": true,
      "16880": true,
      "16900": true
    },
    "Tláhuac": {
      "13000": true,
      "13010": true,
      "13020": true,
      "13030": true,
      "13040": true,
      "13050": true,
      "13060": true,
      "13070": true,
      "13080": true,
      "13090": true,
      "13093": true,
      "13094": true,
      "13099": true,
      "13100": true,
      "13120": true,
      "13150": true,
      "13180": true,
      "13200": true,
      "13210": true,
      "13219": true,
      "13220": true,
      "13230": true,
      "13250": true,
      "13270": true,
      "13273": true,
      "13278": true,
      "13280": true,
      "13300": true,
      "13310": true,
      "13315": true,
      "13319": true,
      "13360": true,
      "13400": true,
      "13410": true,
      "13419": true,
      "13420": true,
      "13430": true,
      "13440": true,
      "13450": true,
      "13460": true,
      "13508": true,
      "13509": true,
      "13510": true,
      "13520": true,
      "13530": true,
      "13540": true,
      "13545": true,
      "13549": true,
      "13550": true,
      "13600": true,
      "13610": true,
      "13625": true,
      "13630": true,
      "13640": true,
      "13700": true
    },
    "Milpa Alta": {
      "12000": true,
      "12070": true,
      "12080": true,
      "12100": true,
      "12110": true,
      "12200": true,
      "12250": true,
      "12300": true,
      "12400": true,
      "12410": true,
      "12500": true,
      "12600": true,
      "12700": true,
      "12800": true,
      "12910": true,
      "12920": true,
      "12930": true,
      "12940": true,
      "12950": true
    },
    "Cuajimalpa de Morelos": {
      "5000": true,
      "5010": true,
      "5020": true,
      "5030": true,
      "5050": true,
      "5100": true,
      "5110": true,
      "5118": true,
      "5119": true,
      "5120": true,
      "5129": true,
      "5200": true,
      "5219": true,
      "5220": true,
      "5230": true,
      "5240": true,
      "5260": true,
      "5269": true,
      "5270": true,
      "5280": true,
      "5310": true,
      "5320": true,
      "5330": true,
      "5348": true,
      "5360": true,
      "5370": true,
      "5379": true,
      "5400": true,
      "5410": true,
      "5500": true,
      "5520": true,
      "5530": true,
      "5600": true,
      "5610": true,
      "5700": true,
      "5710": true,
      "5730": true,
      "5750": true,
      "5760": true,
      "5780": true
    }
  },
  "México": {
    "Huixquilucan": {
      "52770": true,
      "52780": true,
      "52784": true
    },
    "Atizapán de Zaragoza": {
      "52900": true,
      "52910": true,
      "52915": true,
      "52918": true,
      "52919": true,
      "52920": true,
      "52923": true,
      "52924": true,
      "52925": true,
      "52926": true,
      "52927": true,
      "52928": true,
      "52929": true,
      "52940": true,
      "52945": true,
      "52946": true,
      "52947": true,
      "52948": true,
      "52949": true,
      "52950": true,
      "52953": true,
      "52957": true,
      "52959": true,
      "52960": true,
      "52965": true,
      "52966": true,
      "52967": true,
      "52968": true,
      "52970": true,
      "52975": true,
      "52976": true,
      "52977": true,
      "52978": true,
      "52979": true,
      "52985": true,
      "52986": true,
      "52987": true,
      "52988": true,
      "52990": true,
      "52994": true,
      "52995": true,
      "52996": true,
      "52997": true,
      "52998": true
    },
    "Tlalnepantla de Baz": {
      "54000": true,
      "54009": true,
      "54010": true,
      "54015": true,
      "54016": true,
      "54017": true,
      "54020": true,
      "54021": true,
      "54022": true,
      "54023": true,
      "54025": true,
      "54026": true,
      "54028": true,
      "54030": true,
      "54033": true,
      "54037": true,
      "54038": true,
      "54040": true,
      "54049": true,
      "54050": true,
      "54054": true,
      "54055": true,
      "54057": true,
      "54059": true,
      "54060": true,
      "54063": true,
      "54067": true,
      "54068": true,
      "54069": true,
      "54070": true,
      "54073": true,
      "54075": true,
      "54076": true,
      "54080": true,
      "54090": true,
      "54092": true,
      "54093": true,
      "54094": true,
      "54098": true,
      "54100": true,
      "54108": true,
      "54109": true,
      "54110": true,
      "54118": true,
      "54119": true,
      "54120": true,
      "54124": true,
      "54126": true,
      "54127": true,
      "54128": true,
      "54130": true,
      "54134": true,
      "54135": true,
      "54136": true,
      "54140": true,
      "54142": true,
      "54143": true,
      "54145": true,
      "54146": true,
      "54147": true,
      "54149": true,
      "54150": true,
      "54152": true,
      "54158": true,
      "54160": true,
      "54162": true,
      "54168": true,
      "54170": true,
      "54172": true,
      "54173": true,
      "54180": true,
      "54187": true,
      "54189": true,
      "54190": true,
      "54193": true,
      "54195": true,
      "54196": true,
      "54197": true,
      "54198": true
    },
    "Naucalpan de Juárez": {
      "53000": true,
      "53010": true,
      "53030": true,
      "53040": true,
      "53050": true,
      "53060": true,
      "53070": true,
      "53100": true,
      "53110": true,
      "53115": true,
      "53116": true,
      "53117": true,
      "53119": true,
      "53125": true,
      "53127": true,
      "53128": true,
      "53129": true,
      "53130": true,
      "53138": true,
      "53140": true,
      "53150": true,
      "53160": true,
      "53170": true,
      "53177": true,
      "53178": true,
      "53200": true,
      "53215": true,
      "53218": true,
      "53220": true,
      "53224": true,
      "53227": true,
      "53230": true,
      "53237": true,
      "53239": true,
      "53240": true,
      "53247": true,
      "53248": true,
      "53250": true,
      "53260": true,
      "53270": true,
      "53278": true,
      "53279": true,
      "53280": true,
      "53283": true,
      "53290": true,
      "53296": true,
      "53297": true,
      "53298": true,
      "53300": true,
      "53309": true,
      "53310": true,
      "53320": true,
      "53329": true,
      "53330": true,
      "53338": true,
      "53339": true,
      "53340": true,
      "53348": true,
      "53350": true,
      "53370": true,
      "53378": true,
      "53390": true,
      "53398": true,
      "53400": true,
      "53410": true,
      "53420": true,
      "53425": true,
      "53426": true,
      "53427": true,
      "53428": true,
      "53430": true,
      "53440": true,
      "53450": true,
      "53458": true,
      "53459": true,
      "53460": true,
      "53470": true,
      "53489": true,
      "53490": true,
      "53500": true,
      "53519": true,
      "53520": true,
      "53529": true,
      "53530": true,
      "53533": true,
      "53550": true,
      "53560": true,
      "53569": true,
      "53570": true,
      "53580": true,
      "53598": true,
      "53670": true,
      "53696": true,
      "53697": true,
      "53698": true,
      "53710": true,
      "53713": true,
      "53717": true,
      "53718": true,
      "53719": true,
      "53770": true,
      "53780": true,
      "53787": true,
      "53790": true,
      "53798": true,
      "53799": true,
      "53800": true,
      "53809": true,
      "53810": true,
      "53819": true,
      "53820": true,
      "53830": true,
      "53839": true,
      "53840": true,
      "53900": true,
      "53909": true,
      "53910": true,
      "53930": true,
      "53940": true,
      "53950": true,
      "53960": true,
      "53970": true
    },
    "Nicolás Romero": {
      "54473": true,
      "54474": true,
      "54475": true,
      "54476": true
    },
    "Cuautitlán Izcalli": {
      "54700": true,
      "54712": true,
      "54720": true,
      "54725": true,
      "54729": true,
      "54730": true,
      "54740": true,
      "54743": true,
      "54744": true,
      "54750": true,
      "54753": true,
      "54759": true,
      "54760": true,
      "54763": true,
      "54764": true,
      "54765": true,
      "54766": true,
      "54767": true,
      "54769": true
    },
    "Cuautitlán": {
      "54800": true,
      "54804": true,
      "54805": true,
      "54807": true,
      "54850": true,
      "54855": true,
      "54857": true,
      "54858": true,
      "54860": true,
      "54870": true,
      "54875": true,
      "54877": true,
      "54878": true,
      "54879": true
    },
    "Tultitlán": {
      "54900": true,
      "54910": true,
      "54913": true,
      "54914": true,
      "54915": true,
      "54916": true,
      "54918": true,
      "54920": true,
      "54924": true,
      "54925": true,
      "54926": true,
      "54927": true,
      "54929": true,
      "54930": true,
      "54932": true,
      "54933": true,
      "54934": true,
      "54935": true,
      "54938": true,
      "54939": true,
      "54940": true,
      "54942": true,
      "54943": true,
      "54944": true,
      "54945": true,
      "54946": true,
      "54948": true,
      "54949": true,
      "54950": true,
      "54954": true,
      "54955": true,
      "54957": true,
      "54958": true,
      "54959": true
    },
    "Ecatepec de Morelos": {
      "55000": true,
      "55010": true,
      "55014": true,
      "55016": true,
      "55017": true,
      "55018": true,
      "55020": true,
      "55023": true,
      "55024": true,
      "55025": true,
      "55027": true,
      "55028": true,
      "55029": true,
      "55030": true,
      "55036": true,
      "55037": true,
      "55038": true,
      "55039": true,
      "55040": true,
      "55050": true,
      "55055": true,
      "55056": true,
      "55059": true,
      "55060": true,
      "55064": true,
      "55065": true,
      "55066": true,
      "55067": true,
      "55068": true,
      "55069": true,
      "55070": true,
      "55074": true,
      "55075": true,
      "55076": true,
      "55080": true,
      "55084": true,
      "55085": true,
      "55090": true,
      "55094": true,
      "55095": true,
      "55100": true,
      "55104": true,
      "55105": true,
      "55107": true,
      "55114": true,
      "55115": true,
      "55117": true,
      "55118": true,
      "55119": true,
      "55120": true,
      "55125": true,
      "55126": true,
      "55127": true,
      "55128": true,
      "55129": true,
      "55130": true,
      "55135": true,
      "55137": true,
      "55138": true,
      "55139": true,
      "55140": true,
      "55146": true,
      "55147": true,
      "55148": true,
      "55149": true,
      "55158": true,
      "55170": true,
      "55176": true,
      "55180": true,
      "55187": true,
      "55188": true,
      "55189": true,
      "55190": true,
      "55200": true,
      "55210": true,
      "55218": true,
      "55220": true,
      "55230": true,
      "55234": true,
      "55235": true,
      "55236": true,
      "55237": true,
      "55238": true,
      "55240": true,
      "55242": true,
      "55243": true,
      "55244": true,
      "55245": true,
      "55246": true,
      "55247": true,
      "55248": true,
      "55249": true,
      "55260": true,
      "55264": true,
      "55266": true,
      "55267": true,
      "55268": true,
      "55269": true,
      "55270": true,
      "55280": true,
      "55284": true,
      "55287": true,
      "55288": true,
      "55289": true,
      "55290": true,
      "55294": true,
      "55295": true,
      "55296": true,
      "55297": true,
      "55298": true,
      "55299": true,
      "55300": true,
      "55308": true,
      "55310": true,
      "55316": true,
      "55317": true,
      "55320": true,
      "55330": true,
      "55338": true,
      "55339": true,
      "55340": true,
      "55347": true,
      "55348": true,
      "55349": true,
      "55360": true,
      "55369": true,
      "55390": true,
      "55400": true,
      "55404": true,
      "55405": true,
      "55407": true,
      "55410": true,
      "55414": true,
      "55415": true,
      "55416": true,
      "55417": true,
      "55418": true,
      "55419": true,
      "55420": true,
      "55425": true,
      "55429": true,
      "55430": true,
      "55450": true,
      "55458": true,
      "55459": true,
      "55490": true,
      "55498": true,
      "55500": true,
      "55506": true,
      "55507": true,
      "55508": true,
      "55509": true,
      "55510": true,
      "55515": true,
      "55516": true,
      "55517": true,
      "55518": true,
      "55519": true,
      "55520": true,
      "55530": true,
      "55540": true,
      "55547": true,
      "55548": true,
      "55549": true
    },
    "Tultepec": {
      "54963": true,
      "54980": true,
      "54983": true,
      "54984": true,
      "54985": true,
      "54986": true,
      "54987": true
    },
    "Coacalco de Berriozábal": {
      "55700": true,
      "55705": true,
      "55707": true,
      "55708": true,
      "55709": true,
      "55710": true,
      "55712": true,
      "55713": true,
      "55714": true,
      "55715": true,
      "55716": true,
      "55717": true,
      "55718": true,
      "55719": true,
      "55720": true,
      "55726": true,
      "55728": true,
      "55729": true,
      "55730": true,
      "55736": true,
      "55737": true,
      "55738": true,
      "55739": true
    },
    "Tecámac": {
      "55763": true,
      "55764": true
    },
    "Jaltenco": {
      "55783": true
    },
    "Chimalhuacán": {
      "56330": true,
      "56334": true,
      "56335": true,
      "56337": true,
      "56340": true,
      "56343": true,
      "56344": true,
      "56346": true,
      "56350": true,
      "56353": true,
      "56356": true,
      "56360": true,
      "56363": true,
      "56366": true
    },
    "Chicoloapan": {
      "56390": true
    },
    "La Paz": {
      "56400": true,
      "56410": true,
      "56420": true,
      "56428": true,
      "56429": true,
      "56430": true,
      "56440": true,
      "56490": true,
      "56500": true,
      "56505": true,
      "56520": true,
      "56524": true,
      "56525": true,
      "56526": true,
      "56527": true,
      "56528": true,
      "56529": true
    },
    "Nezahualcóyotl": {
      "57000": true,
      "57100": true,
      "57103": true,
      "57120": true,
      "57129": true,
      "57130": true,
      "57138": true,
      "57139": true,
      "57140": true,
      "57150": true,
      "57158": true,
      "57170": true,
      "57171": true,
      "57178": true,
      "57179": true,
      "57180": true,
      "57185": true,
      "57188": true,
      "57189": true,
      "57200": true,
      "57205": true,
      "57210": true,
      "57300": true,
      "57310": true,
      "57400": true,
      "57410": true,
      "57420": true,
      "57430": true,
      "57440": true,
      "57450": true,
      "57460": true,
      "57500": true,
      "57510": true,
      "57520": true,
      "57530": true,
      "57600": true,
      "57610": true,
      "57620": true,
      "57630": true,
      "57700": true,
      "57708": true,
      "57709": true,
      "57710": true,
      "57718": true,
      "57719": true,
      "57720": true,
      "57730": true,
      "57739": true,
      "57740": true,
      "57750": true,
      "57760": true,
      "57800": true,
      "57809": true,
      "57810": true,
      "57819": true,
      "57820": true,
      "57830": true,
      "57840": true,
      "57849": true,
      "57900": true,
      "57910": true,
      "57920": true,
      "57930": true,
      "57940": true,
      "57950": true
    },
    "Toluca": {
      "50000": true,
      "50010": true,
      "50016": true,
      "50020": true,
      "50026": true,
      "50040": true,
      "50050": true,
      "50060": true,
      "50070": true,
      "50071": true,
      "50075": true,
      "50080": true,
      "50090": true,
      "50100": true,
      "50103": true,
      "50110": true,
      "50115": true,
      "50120": true,
      "50122": true,
      "50130": true,
      "50140": true,
      "50150": true,
      "50160": true,
      "50168": true,
      "50170": true,
      "50180": true,
      "50190": true,
      "50200": true,
      "50205": true,
      "50206": true,
      "50210": true,
      "50214": true,
      "50220": true,
      "50225": true,
      "50226": true,
      "50227": true,
      "50228": true,
      "50240": true,
      "50245": true,
      "50246": true,
      "50250": true,
      "50253": true,
      "50254": true,
      "50260": true,
      "50263": true,
      "50264": true,
      "50265": true,
      "50290": true,
      "50294": true
    },
    "Zinacantepec": {
      "51356": true
    },
    "Lerma": {
      "52004": true
    },
    "San Mateo Atenco": {
      "52100": true,
      "52104": true,
      "52105": true,
      "52110": true,
      "52120": true
    },
    "Metepec": {
      "52140": true,
      "52148": true,
      "52149": true,
      "52150": true,
      "52156": true,
      "52157": true,
      "52158": true,
      "52159": true,
      "52160": true,
      "52164": true,
      "52165": true,
      "52166": true,
      "52167": true,
      "52168": true,
      "52169": true,
      "52170": true,
      "52172": true,
      "52175": true,
      "52176": true,
      "52177": true,
      "52178": true,
      "52179": true
    }
  },
  "Jalisco": {
    "Guadalajara": {
      "44100": true,
      "44110": true,
      "44130": true,
      "44140": true,
      "44150": true,
      "44158": true,
      "44160": true,
      "44170": true,
      "44180": true,
      "44190": true,
      "44200": true,
      "44210": true,
      "44214": true,
      "44215": true,
      "44216": true,
      "44217": true,
      "44218": true,
      "44219": true,
      "44220": true,
      "44227": true,
      "44230": true,
      "44240": true,
      "44246": true,
      "44247": true,
      "44260": true,
      "44265": true,
      "44266": true,
      "44267": true,
      "44270": true,
      "44280": true,
      "44290": true,
      "44298": true,
      "44299": true,
      "44300": true,
      "44306": true,
      "44307": true,
      "44320": true,
      "44329": true,
      "44330": true,
      "44340": true,
      "44350": true,
      "44360": true,
      "44370": true,
      "44380": true,
      "44400": true,
      "44410": true,
      "44420": true,
      "44430": true,
      "44440": true,
      "44450": true,
      "44460": true,
      "44467": true,
      "44469": true,
      "44470": true,
      "44490": true,
      "44493": true,
      "44500": true,
      "44509": true,
      "44510": true,
      "44520": true,
      "44530": true,
      "44535": true,
      "44538": true,
      "44540": true,
      "44549": true,
      "44550": true,
      "44559": true,
      "44560": true,
      "44580": true,
      "44600": true,
      "44610": true,
      "44619": true,
      "44620": true,
      "44630": true,
      "44635": true,
      "44647": true,
      "44648": true,
      "44650": true,
      "44656": true,
      "44657": true,
      "44658": true,
      "44660": true,
      "44665": true,
      "44667": true,
      "44668": true,
      "44670": true,
      "44678": true,
      "44679": true,
      "44680": true,
      "44689": true,
      "44690": true,
      "44700": true,
      "44710": true,
      "44716": true,
      "44719": true,
      "44720": true,
      "44723": true,
      "44724": true,
      "44725": true,
      "44726": true,
      "44727": true,
      "44730": true,
      "44737": true,
      "44740": true,
      "44748": true,
      "44750": true,
      "44755": true,
      "44757": true,
      "44765": true,
      "44770": true,
      "44780": true,
      "44790": true,
      "44799": true,
      "44800": true,
      "44810": true,
      "44815": true,
      "44817": true,
      "44818": true,
      "44820": true,
      "44824": true,
      "44825": true,
      "44827": true,
      "44828": true,
      "44829": true,
      "44840": true,
      "44860": true,
      "44870": true,
      "44890": true,
      "44895": true,
      "44896": true,
      "44897": true,
      "44898": true,
      "44899": true,
      "44900": true,
      "44910": true,
      "44918": true,
      "44919": true,
      "44920": true,
      "44929": true,
      "44930": true,
      "44940": true,
      "44948": true,
      "44949": true,
      "44950": true,
      "44956": true,
      "44959": true,
      "44960": true,
      "44966": true,
      "44967": true,
      "44969": true,
      "44970": true,
      "44977": true,
      "44978": true,
      "44980": true,
      "44984": true,
      "44985": true,
      "44986": true,
      "44987": true,
      "44989": true,
      "44990": true
    },
    "Zapopan": {
      "45010": true,
      "45016": true,
      "45018": true,
      "45020": true,
      "45027": true,
      "45030": true,
      "45034": true,
      "45036": true,
      "45037": true,
      "45038": true,
      "45039": true,
      "45040": true,
      "45047": true,
      "45049": true,
      "45050": true,
      "45053": true,
      "45054": true,
      "45055": true,
      "45056": true,
      "45057": true,
      "45058": true,
      "45059": true,
      "45060": true,
      "45066": true,
      "45067": true,
      "45069": true,
      "45070": true,
      "45076": true,
      "45077": true,
      "45078": true,
      "45079": true,
      "45080": true,
      "45085": true,
      "45086": true,
      "45087": true,
      "45088": true,
      "45089": true,
      "45100": true,
      "45110": true,
      "45115": true,
      "45116": true,
      "45117": true,
      "45118": true,
      "45119": true,
      "45120": true,
      "45128": true,
      "45129": true,
      "45130": true,
      "45136": true,
      "45138": true,
      "45140": true,
      "45145": true,
      "45146": true,
      "45147": true,
      "45148": true,
      "45149": true,
      "45150": true,
      "45157": true,
      "45158": true,
      "45159": true,
      "45160": true,
      "45167": true,
      "45168": true,
      "45169": true,
      "45170": true,
      "45176": true,
      "45177": true,
      "45178": true,
      "45179": true,
      "45180": true,
      "45184": true,
      "45190": true,
      "45230": true,
      "45234": true,
      "45235": true,
      "45236": true,
      "45237": true,
      "45238": true,
      "45239": true
    },
    "Tonalá": {
      "45400": true,
      "45402": true,
      "45403": true
    },
    "San Pedro Tlaquepaque": {
      "45500": true,
      "45509": true,
      "45510": true,
      "45519": true,
      "45520": true,
      "45525": true,
      "45527": true,
      "45528": true,
      "45530": true,
      "45535": true,
      "45540": true,
      "45550": true,
      "45559": true,
      "45560": true,
      "45567": true,
      "45570": true,
      "45579": true,
      "45580": true,
      "45588": true,
      "45589": true,
      "45590": true,
      "45593": true,
      "45594": true,
      "45595": true,
      "45596": true,
      "45597": true,
      "45598": true,
      "45599": true,
      "45601": true,
      "45604": true,
      "45605": true,
      "45606": true,
      "45607": true,
      "45608": true,
      "45609": true,
      "45610": true,
      "45619": true,
      "45620": true,
      "45623": true,
      "45625": true,
      "45626": true,
      "45627": true,
      "45628": true,
      "45629": true,
      "45630": true,
      "45638": true
    }
  },
  "Puebla": {
    "Puebla": {
      "72000": true,
      "72010": true,
      "72020": true,
      "72023": true,
      "72029": true,
      "72030": true,
      "72040": true,
      "72044": true,
      "72045": true,
      "72050": true,
      "72060": true,
      "72062": true,
      "72070": true,
      "72080": true,
      "72089": true,
      "72090": true,
      "72094": true,
      "72110": true,
      "72114": true,
      "72115": true,
      "72120": true,
      "72124": true,
      "72127": true,
      "72130": true,
      "72135": true,
      "72140": true,
      "72150": true,
      "72154": true,
      "72160": true,
      "72170": true,
      "72176": true,
      "72180": true,
      "72189": true,
      "72190": true,
      "72193": true,
      "72194": true,
      "72200": true,
      "72210": true,
      "72220": true,
      "72223": true,
      "72225": true,
      "72228": true,
      "72230": true,
      "72240": true,
      "72243": true,
      "72250": true,
      "72260": true,
      "72266": true,
      "72267": true,
      "72270": true,
      "72280": true,
      "72290": true,
      "72300": true,
      "72303": true,
      "72304": true,
      "72307": true,
      "72308": true,
      "72309": true,
      "72310": true,
      "72314": true,
      "72320": true,
      "72330": true,
      "72340": true,
      "72350": true,
      "72359": true,
      "72360": true,
      "72365": true,
      "72370": true,
      "72373": true,
      "72377": true,
      "72380": true,
      "72390": true,
      "72400": true,
      "72403": true,
      "72410": true,
      "72420": true,
      "72423": true,
      "72424": true,
      "72425": true,
      "72430": true,
      "72440": true,
      "72450": true,
      "72453": true,
      "72456": true,
      "72459": true,
      "72460": true,
      "72464": true,
      "72468": true,
      "72470": true,
      "72474": true,
      "72477": true,
      "72478": true,
      "72480": true,
      "72482": true,
      "72483": true,
      "72484": true,
      "72490": true,
      "72492": true,
      "72494": true,
      "72496": true,
      "72498": true,
      "72500": true,
      "72501": true,
      "72503": true,
      "72504": true,
      "72505": true,
      "72510": true,
      "72520": true,
      "72523": true,
      "72530": true,
      "72532": true,
      "72533": true,
      "72534": true,
      "72538": true,
      "72540": true,
      "72543": true,
      "72550": true,
      "72560": true,
      "72564": true,
      "72565": true,
      "72567": true,
      "72570": true,
      "72573": true,
      "72574": true,
      "72575": true,
      "72580": true,
      "72582": true,
      "72583": true,
      "72584": true,
      "72587": true,
      "72589": true,
      "72590": true,
      "72592": true,
      "72593": true,
      "72594": true
    },
    "Cuautlancingo": {
      "72700": true,
      "72702": true,
      "72703": true,
      "72704": true,
      "72705": true,
      "72706": true,
      "72707": true,
      "72720": true,
      "72723": true,
      "72724": true,
      "72730": true,
      "72733": true,
      "72735": true
    },
    "Juan C. Bonilla": {
      "72640": true,
      "72669": true
    },
    "Coronango": {
      "72670": true,
      "72680": true,
      "72683": true,
      "72685": true
    },
    "San Pedro Cholula": {
      "72750": true,
      "72754": true,
      "72755": true,
      "72757": true,
      "72760": true,
      "72762": true,
      "72764": true,
      "72765": true,
      "72766": true,
      "72767": true,
      "72768": true,
      "72770": true,
      "72772": true,
      "72774": true,
      "72775": true,
      "72776": true,
      "72777": true,
      "72778": true
    },
    "San Andrés Cholula": {
      "72803": true,
      "72805": true,
      "72810": true,
      "72813": true,
      "72814": true,
      "72815": true,
      "72817": true,
      "72819": true,
      "72820": true,
      "72823": true,
      "72824": true,
      "72825": true,
      "72826": true,
      "72828": true,
      "72830": true,
      "72833": true,
      "72835": true,
      "72836": true,
      "72837": true,
      "72840": true,
      "72843": true,
      "72846": true
    }
  },
  "Nuevo León": {
    "Monterrey": {
      "64000": true,
      "64010": true,
      "64018": true,
      "64019": true,
      "64020": true,
      "64030": true,
      "64040": true,
      "64049": true,
      "64050": true,
      "64060": true,
      "64070": true,
      "64100": true,
      "64102": true,
      "64103": true,
      "64104": true,
      "64105": true,
      "64106": true,
      "64107": true,
      "64108": true,
      "64109": true,
      "64110": true,
      "64116": true,
      "64117": true,
      "64118": true,
      "64119": true,
      "64120": true,
      "64130": true,
      "64140": true,
      "64145": true,
      "64148": true,
      "64150": true,
      "64157": true,
      "64158": true,
      "64159": true,
      "64160": true,
      "64165": true,
      "64167": true,
      "64168": true,
      "64170": true,
      "64178": true,
      "64180": true,
      "64186": true,
      "64190": true,
      "64200": true,
      "64204": true,
      "64205": true,
      "64206": true,
      "64208": true,
      "64209": true,
      "64210": true,
      "64215": true,
      "64217": true,
      "64218": true,
      "64219": true,
      "64220": true,
      "64226": true,
      "64228": true,
      "64230": true,
      "64233": true,
      "64234": true,
      "64235": true,
      "64236": true,
      "64238": true,
      "64240": true,
      "64244": true,
      "64245": true,
      "64246": true,
      "64247": true,
      "64250": true,
      "64259": true,
      "64260": true,
      "64264": true,
      "64265": true,
      "64266": true,
      "64268": true,
      "64269": true,
      "64270": true,
      "64280": true,
      "64290": true,
      "64299": true,
      "64300": true,
      "64310": true,
      "64320": true,
      "64330": true,
      "64339": true,
      "64340": true,
      "64344": true,
      "64345": true,
      "64346": true,
      "64347": true,
      "64348": true,
      "64349": true,
      "64350": true,
      "64360": true,
      "64365": true,
      "64366": true,
      "64367": true,
      "64368": true,
      "64369": true,
      "64370": true,
      "64380": true,
      "64390": true,
      "64400": true,
      "64410": true,
      "64420": true,
      "64430": true,
      "64440": true,
      "64450": true,
      "64460": true,
      "64470": true,
      "64480": true,
      "64488": true,
      "64489": true,
      "64490": true,
      "64500": true,
      "64508": true,
      "64510": true,
      "64517": true,
      "64520": true,
      "64530": true,
      "64536": true,
      "64540": true,
      "64549": true,
      "64550": true,
      "64560": true,
      "64568": true,
      "64570": true,
      "64580": true,
      "64590": true,
      "64600": true,
      "64610": true,
      "64618": true,
      "64619": true,
      "64620": true,
      "64623": true,
      "64630": true,
      "64632": true,
      "64633": true,
      "64634": true,
      "64635": true,
      "64636": true,
      "64637": true,
      "64638": true,
      "64639": true,
      "64640": true,
      "64649": true,
      "64650": true,
      "64659": true,
      "64660": true,
      "64700": true,
      "64710": true,
      "64715": true,
      "64718": true,
      "64720": true,
      "64730": true,
      "64740": true,
      "64750": true,
      "64753": true,
      "64754": true,
      "64760": true,
      "64764": true,
      "64765": true,
      "64770": true,
      "64780": true,
      "64783": true,
      "64788": true,
      "64790": true,
      "64798": true,
      "64800": true,
      "64810": true,
      "64820": true,
      "64830": true,
      "64833": true,
      "64834": true,
      "64836": true,
      "64840": true,
      "64844": true,
      "64845": true,
      "64849": true,
      "64850": true,
      "64858": true,
      "64859": true,
      "64860": true,
      "64865": true,
      "64878": true,
      "64880": true,
      "64890": true,
      "64893": true,
      "64898": true,
      "64900": true,
      "64909": true,
      "64910": true,
      "64920": true,
      "64926": true,
      "64930": true,
      "64940": true,
      "64949": true,
      "64950": true,
      "64960": true,
      "64968": true,
      "64969": true,
      "64970": true,
      "64978": true,
      "64983": true,
      "64984": true,
      "64985": true,
      "64986": true,
      "64987": true,
      "64988": true,
      "64989": true,
      "64990": true,
      "64996": true
    },
    "General Escobedo": {
      "66050": true,
      "66051": true,
      "66052": true,
      "66053": true,
      "66054": true,
      "66055": true,
      "66056": true,
      "66057": true,
      "66058": true,
      "66059": true,
      "66061": true,
      "66062": true,
      "66064": true,
      "66070": true,
      "66072": true,
      "66073": true
    },
    "Santa Catarina": {
      "66100": true,
      "66110": true,
      "66114": true,
      "66115": true,
      "66116": true,
      "66117": true,
      "66118": true,
      "66119": true,
      "66120": true,
      "66129": true,
      "66139": true,
      "66140": true,
      "66145": true,
      "66147": true,
      "66149": true,
      "66150": true,
      "66160": true,
      "66165": true,
      "66166": true,
      "66167": true,
      "66168": true,
      "66169": true,
      "66170": true,
      "66179": true,
      "66180": true,
      "66187": true,
      "66188": true,
      "66189": true,
      "66190": true,
      "66195": true,
      "66196": true,
      "66197": true,
      "66198": true,
      "66199": true,
      "66350": true,
      "66353": true,
      "66354": true,
      "66356": true,
      "66357": true,
      "66358": true,
      "66360": true,
      "66362": true,
      "66363": true,
      "66364": true,
      "66365": true,
      "66366": true,
      "66367": true,
      "66368": true,
      "66369": true,
      "66370": true,
      "66373": true,
      "66374": true,
      "66375": true,
      "66376": true,
      "66377": true,
      "66378": true
    },
    "San Pedro Garza García": {
      "66200": true,
      "66210": true,
      "66214": true,
      "66215": true,
      "66216": true,
      "66217": true,
      "66218": true,
      "66219": true,
      "66220": true,
      "66224": true,
      "66225": true,
      "66226": true,
      "66227": true,
      "66228": true,
      "66230": true,
      "66233": true,
      "66235": true,
      "66236": true,
      "66237": true,
      "66238": true,
      "66239": true,
      "66240": true,
      "66244": true,
      "66245": true,
      "66247": true,
      "66249": true,
      "66250": true,
      "66254": true,
      "66256": true,
      "66257": true,
      "66259": true,
      "66260": true,
      "66263": true,
      "66265": true,
      "66266": true,
      "66267": true,
      "66268": true,
      "66270": true,
      "66273": true,
      "66276": true,
      "66277": true,
      "66280": true,
      "66285": true,
      "66287": true,
      "66295": true,
      "66297": true
    },
    "San Nicolás de los Garza": {
      "66400": true,
      "66410": true,
      "66413": true,
      "66414": true,
      "66415": true,
      "66417": true,
      "66418": true,
      "66420": true,
      "66422": true,
      "66425": true,
      "66427": true,
      "66428": true,
      "66430": true,
      "66435": true,
      "66436": true,
      "66437": true,
      "66438": true,
      "66440": true,
      "66444": true,
      "66445": true,
      "66446": true,
      "66447": true,
      "66448": true,
      "66449": true,
      "66450": true,
      "66455": true,
      "66456": true,
      "66457": true,
      "66458": true,
      "66460": true,
      "66463": true,
      "66465": true,
      "66466": true,
      "66468": true,
      "66469": true,
      "66470": true,
      "66473": true,
      "66475": true,
      "66476": true,
      "66477": true,
      "66478": true,
      "66479": true,
      "66480": true,
      "66482": true,
      "66484": true,
      "66485": true,
      "66486": true,
      "66488": true,
      "66489": true,
      "66490": true,
      "66494": true,
      "66495": true,
      "66496": true,
      "66499": true
    },
    "Apodaca": {
      "66600": true,
      "66603": true,
      "66604": true,
      "66605": true,
      "66606": true,
      "66607": true,
      "66609": true,
      "66610": true,
      "66612": true,
      "66613": true,
      "66614": true,
      "66630": true,
      "66632": true,
      "66633": true,
      "66634": true,
      "66635": true,
      "66636": true,
      "66637": true,
      "66640": true,
      "66643": true,
      "66644": true,
      "66645": true,
      "66646": true,
      "66647": true,
      "66648": true,
      "66649": true
    },
    "Guadalupe": {
      "67100": true,
      "67110": true,
      "67112": true,
      "67113": true,
      "67115": true,
      "67116": true,
      "67117": true,
      "67118": true,
      "67119": true,
      "67120": true,
      "67123": true,
      "67124": true,
      "67125": true,
      "67126": true,
      "67128": true,
      "67129": true,
      "67130": true,
      "67132": true,
      "67133": true,
      "67134": true,
      "67140": true,
      "67144": true,
      "67150": true,
      "67153": true,
      "67154": true,
      "67155": true,
      "67160": true,
      "67163": true,
      "67164": true,
      "67165": true,
      "67167": true,
      "67168": true,
      "67169": true,
      "67170": true,
      "67173": true,
      "67174": true,
      "67175": true,
      "67176": true,
      "67177": true,
      "67178": true,
      "67179": true,
      "67180": true,
      "67182": true,
      "67183": true,
      "67184": true,
      "67185": true,
      "67186": true,
      "67188": true,
      "67189": true,
      "67190": true,
      "67192": true,
      "67193": true,
      "67194": true,
      "67195": true,
      "67196": true,
      "67197": true,
      "67198": true,
      "67199": true,
      "67200": true,
      "67202": true,
      "67203": true,
      "67204": true,
      "67205": true
    },
    "García": {
      "66023": true,
      "66024": true
    },
    "Juárez": {
      "67258": true,
      "67287": true,
      "67288": true,
      "67289": true
    }
  },
  "Querétaro": {
    "Querétaro": {
      "76000": true,
      "76010": true,
      "76017": true,
      "76020": true,
      "76024": true,
      "76025": true,
      "76026": true,
      "76027": true,
      "76028": true,
      "76030": true,
      "76036": true,
      "76037": true,
      "76040": true,
      "76046": true,
      "76047": true,
      "76048": true,
      "76049": true,
      "76050": true,
      "76057": true,
      "76058": true,
      "76059": true,
      "76060": true,
      "76063": true,
      "76067": true,
      "76069": true,
      "76070": true,
      "76074": true,
      "76078": true,
      "76079": true,
      "76080": true,
      "76085": true,
      "76086": true,
      "76087": true,
      "76090": true,
      "76093": true,
      "76099": true,
      "76100": true,
      "76110": true,
      "76113": true,
      "76114": true,
      "76115": true,
      "76116": true,
      "76117": true,
      "76118": true,
      "76120": true,
      "76121": true,
      "76125": true,
      "76127": true,
      "76130": true,
      "76134": true,
      "76135": true,
      "76136": true,
      "76137": true,
      "76138": true,
      "76139": true,
      "76140": true,
      "76144": true,
      "76146": true,
      "76147": true,
      "76148": true,
      "76149": true,
      "76150": true,
      "76154": true,
      "76155": true,
      "76156": true,
      "76157": true,
      "76158": true,
      "76159": true,
      "76160": true,
      "76164": true,
      "76165": true,
      "76166": true,
      "76168": true,
      "76169": true,
      "76170": true,
      "76175": true,
      "76176": true,
      "76177": true,
      "76178": true,
      "76179": true,
      "76180": true,
      "76185": true,
      "76190": true,
      "76197": true,
      "76199": true,
      "76226": true,
      "76230": true,
      "76235": true,
      "76238": true
    },
    "El Marqués": {
      "76240": true,
      "76244": true,
      "76246": true
    },
    "Corregidora": {
      "76900": true,
      "76902": true,
      "76903": true,
      "76904": true,
      "76905": true,
      "76906": true,
      "76907": true,
      "76908": true,
      "76910": true,
      "76912": true,
      "76930": true
    }
  },
  "Guanajuato": {
    "León": {
      "37000": true,
      "37004": true,
      "37010": true,
      "37020": true,
      "37100": true,
      "37104": true,
      "37105": true,
      "37106": true,
      "37107": true,
      "37108": true,
      "37109": true,
      "37110": true,
      "37118": true,
      "37119": true,
      "37120": true,
      "37123": true,
      "37125": true,
      "37128": true,
      "37129": true,
      "37130": true,
      "37134": true,
      "37138": true,
      "37140": true,
      "37147": true,
      "37148": true,
      "37149": true,
      "37150": true,
      "37156": true,
      "37157": true,
      "37160": true,
      "37168": true,
      "37170": true,
      "37178": true,
      "37179": true,
      "37180": true,
      "37187": true,
      "37188": true,
      "37189": true,
      "37190": true,
      "37199": true,
      "37200": true,
      "37204": true,
      "37205": true,
      "37207": true,
      "37208": true,
      "37209": true,
      "37210": true,
      "37217": true,
      "37218": true,
      "37219": true,
      "37220": true,
      "37225": true,
      "37227": true,
      "37230": true,
      "37233": true,
      "37234": true,
      "37235": true,
      "37236": true,
      "37237": true,
      "37238": true,
      "37239": true,
      "37240": true,
      "37249": true,
      "37250": true,
      "37257": true,
      "37258": true,
      "37259": true,
      "37260": true,
      "37266": true,
      "37267": true,
      "37268": true,
      "37269": true,
      "37270": true,
      "37276": true,
      "37277": true,
      "37278": true,
      "37279": true,
      "37280": true,
      "37287": true,
      "37288": true,
      "37289": true,
      "37290": true,
      "37293": true,
      "37294": true,
      "37295": true,
      "37296": true,
      "37297": true,
      "37298": true,
      "37299": true,
      "37300": true,
      "37306": true,
      "37310": true,
      "37315": true,
      "37316": true,
      "37318": true,
      "37319": true,
      "37320": true,
      "37327": true,
      "37328": true,
      "37330": true,
      "37340": true,
      "37350": true,
      "37353": true,
      "37355": true,
      "37357": true,
      "37358": true,
      "37359": true,
      "37360": true,
      "37364": true,
      "37366": true,
      "37368": true,
      "37369": true,
      "37380": true,
      "37390": true,
      "37400": true,
      "37407": true,
      "37408": true,
      "37410": true,
      "37414": true,
      "37415": true,
      "37416": true,
      "37417": true,
      "37419": true,
      "37420": true,
      "37425": true,
      "37426": true,
      "37427": true,
      "37428": true,
      "37430": true,
      "37434": true,
      "37436": true,
      "37438": true,
      "37439": true,
      "37440": true,
      "37443": true,
      "37444": true,
      "37446": true,
      "37448": true,
      "37450": true,
      "37455": true,
      "37456": true,
      "37457": true,
      "37458": true,
      "37459": true,
      "37460": true,
      "37468": true,
      "37470": true,
      "37477": true,
      "37478": true,
      "37479": true,
      "37480": true,
      "37487": true,
      "37490": true,
      "37500": true,
      "37510": true,
      "37520": true,
      "37526": true,
      "37530": true,
      "37536": true,
      "37538": true,
      "37539": true,
      "37544": true,
      "37545": true,
      "37547": true,
      "37548": true,
      "37549": true,
      "37550": true,
      "37555": true,
      "37557": true,
      "37560": true,
      "37564": true,
      "37570": true,
      "37590": true,
      "37677": true,
      "37680": true,
      "37684": true,
      "37685": true
    }
  },
  "Coahuila de Zaragoza": {
    "Saltillo": {
      "25000": true,
      "25008": true,
      "25010": true,
      "25013": true,
      "25014": true,
      "25015": true,
      "25016": true,
      "25017": true,
      "25019": true,
      "25020": true,
      "25022": true,
      "25023": true,
      "25030": true,
      "25034": true,
      "25036": true,
      "25038": true,
      "25039": true,
      "25040": true,
      "25043": true,
      "25044": true,
      "25045": true,
      "25047": true,
      "25048": true,
      "25049": true,
      "25050": true,
      "25056": true,
      "25057": true,
      "25060": true,
      "25065": true,
      "25067": true,
      "25068": true,
      "25069": true,
      "25070": true,
      "25075": true,
      "25076": true,
      "25077": true,
      "25080": true,
      "25083": true,
      "25084": true,
      "25085": true,
      "25086": true,
      "25087": true,
      "25088": true,
      "25090": true,
      "25092": true,
      "25093": true,
      "25094": true,
      "25096": true,
      "25097": true,
      "25100": true,
      "25107": true,
      "25110": true,
      "25113": true,
      "25114": true,
      "25115": true,
      "25116": true,
      "25117": true,
      "25120": true,
      "25123": true,
      "25124": true,
      "25125": true,
      "25128": true,
      "25130": true,
      "25137": true,
      "25138": true,
      "25140": true,
      "25146": true,
      "25147": true,
      "25150": true,
      "25155": true,
      "25156": true,
      "25157": true,
      "25160": true,
      "25167": true,
      "25168": true,
      "25169": true,
      "25170": true,
      "25179": true,
      "25180": true,
      "25186": true,
      "25188": true,
      "25190": true,
      "25193": true,
      "25194": true,
      "25195": true,
      "25196": true,
      "25197": true,
      "25198": true,
      "25199": true,
      "25200": true,
      "25203": true,
      "25204": true,
      "25205": true,
      "25206": true,
      "25207": true,
      "25208": true,
      "25209": true,
      "25210": true,
      "25215": true,
      "25220": true,
      "25225": true,
      "25230": true,
      "25239": true,
      "25240": true,
      "25250": true,
      "25253": true,
      "25254": true,
      "25256": true,
      "25260": true,
      "25265": true,
      "25270": true,
      "25277": true,
      "25279": true,
      "25280": true,
      "25284": true,
      "25285": true,
      "25286": true,
      "25290": true,
      "25293": true,
      "25294": true,
      "25295": true,
      "25296": true,
      "25297": true,
      "25298": true
    },
    "Arteaga": {
      "25350": true,
      "25352": true,
      "25353": true,
      "25354": true,
      "25355": true,
      "25356": true,
      "25369": true
    },
    "Ramos Arizpe": {
      "25900": true,
      "25902": true,
      "25903": true,
      "25904": true,
      "25905": true
    }
  },
  "San Luis Potosí": {
    "San Luis Potosí": {
      "78000": true,
      "78037": true,
      "78038": true,
      "78040": true,
      "78048": true,
      "78049": true,
      "78100": true,
      "78106": true,
      "78107": true,
      "78109": true,
      "78110": true,
      "78115": true,
      "78116": true,
      "78117": true,
      "78120": true,
      "78130": true,
      "78133": true,
      "78135": true,
      "78136": true,
      "78137": true,
      "78140": true,
      "78143": true,
      "78144": true,
      "78145": true,
      "78146": true,
      "78147": true,
      "78148": true,
      "78150": true,
      "78153": true,
      "78154": true,
      "78165": true,
      "78170": true,
      "78173": true,
      "78174": true,
      "78175": true,
      "78176": true,
      "78177": true,
      "78178": true,
      "78180": true,
      "78183": true,
      "78200": true,
      "78209": true,
      "78210": true,
      "78213": true,
      "78214": true,
      "78215": true,
      "78216": true,
      "78218": true,
      "78219": true,
      "78220": true,
      "78230": true,
      "78234": true,
      "78235": true,
      "78236": true,
      "78238": true,
      "78239": true,
      "78240": true,
      "78250": true,
      "78258": true,
      "78260": true,
      "78268": true,
      "78269": true,
      "78270": true,
      "78280": true,
      "78290": true,
      "78294": true,
      "78295": true,
      "78298": true,
      "78300": true,
      "78306": true,
      "78307": true,
      "78308": true,
      "78309": true,
      "78310": true,
      "78318": true,
      "78319": true,
      "78320": true,
      "78328": true,
      "78330": true,
      "78338": true,
      "78339": true,
      "78340": true,
      "78349": true,
      "78350": true,
      "78356": true,
      "78357": true,
      "78358": true,
      "78359": true,
      "78360": true,
      "78363": true,
      "78364": true,
      "78365": true,
      "78366": true,
      "78367": true,
      "78368": true,
      "78369": true,
      "78370": true,
      "78377": true,
      "78378": true,
      "78379": true,
      "78380": true,
      "78384": true,
      "78385": true,
      "78387": true,
      "78388": true,
      "78389": true,
      "78390": true,
      "78394": true,
      "78396": true,
      "78399": true
    },
    "Soledad de Graciano Sánchez": {
      "78430": true,
      "78432": true,
      "78433": true,
      "78434": true,
      "78435": true,
      "78436": true,
      "78437": true,
      "78438": true
    }
  },
  "Veracruz de Ignacio de la Llave": {
    "Veracruz": {
      "91694": true,
      "91700": true,
      "91708": true,
      "91709": true,
      "91710": true,
      "91712": true,
      "91713": true,
      "91714": true,
      "91715": true,
      "91716": true,
      "91717": true,
      "91718": true,
      "91720": true,
      "91726": true,
      "91727": true,
      "91728": true,
      "91729": true,
      "91730": true,
      "91739": true,
      "91740": true,
      "91749": true,
      "91750": true,
      "91755": true,
      "91756": true,
      "91757": true,
      "91758": true,
      "91759": true,
      "91760": true,
      "91769": true,
      "91770": true,
      "91777": true,
      "91778": true,
      "91779": true,
      "91780": true,
      "91788": true,
      "91789": true,
      "91790": true,
      "91799": true,
      "91800": true,
      "91809": true,
      "91810": true,
      "91817": true,
      "91820": true,
      "91826": true,
      "91829": true,
      "91840": true,
      "91841": true,
      "91850": true,
      "91855": true,
      "91859": true,
      "91860": true,
      "91870": true,
      "91880": true,
      "91890": true,
      "91891": true,
      "91897": true,
      "91898": true,
      "91899": true,
      "91900": true,
      "91910": true,
      "91916": true,
      "91918": true,
      "91919": true,
      "91920": true,
      "91928": true,
      "91930": true,
      "91936": true,
      "91938": true,
      "91940": true,
      "91947": true,
      "91948": true,
      "91960": true,
      "91963": true,
      "91965": true,
      "91968": true,
      "91969": true
    },
    "Boca del Río": {
      "94290": true,
      "94293": true,
      "94294": true,
      "94295": true,
      "94296": true,
      "94297": true,
      "94298": true,
      "94299": true
    }
  },
  "Morelos": {
    "Cuernavaca": {
      "62000": true,
      "62010": true,
      "62017": true,
      "62018": true,
      "62019": true,
      "62020": true,
      "62028": true,
      "62029": true,
      "62030": true,
      "62037": true,
      "62038": true,
      "62039": true,
      "62040": true,
      "62050": true,
      "62057": true,
      "62059": true,
      "62060": true,
      "62070": true,
      "62076": true,
      "62080": true,
      "62083": true,
      "62084": true,
      "62100": true,
      "62115": true,
      "62120": true,
      "62130": true,
      "62136": true,
      "62137": true,
      "62139": true,
      "62140": true,
      "62143": true,
      "62144": true,
      "62145": true,
      "62156": true,
      "62157": true,
      "62159": true,
      "62160": true,
      "62165": true,
      "62166": true,
      "62170": true,
      "62173": true,
      "62175": true,
      "62179": true,
      "62180": true,
      "62190": true,
      "62193": true,
      "62200": true,
      "62203": true,
      "62210": true,
      "62215": true,
      "62220": true,
      "62226": true,
      "62227": true,
      "62228": true,
      "62229": true,
      "62230": true,
      "62233": true,
      "62237": true,
      "62239": true,
      "62240": true,
      "62243": true,
      "62245": true,
      "62247": true,
      "62248": true,
      "62249": true,
      "62250": true,
      "62253": true,
      "62260": true,
      "62269": true,
      "62270": true,
      "62280": true,
      "62283": true,
      "62284": true,
      "62285": true,
      "62290": true,
      "62293": true,
      "62294": true,
      "62295": true,
      "62296": true,
      "62300": true,
      "62303": true,
      "62304": true,
      "62305": true,
      "62320": true,
      "62323": true,
      "62324": true,
      "62325": true,
      "62326": true,
      "62328": true,
      "62329": true,
      "62330": true,
      "62334": true,
      "62335": true,
      "62340": true,
      "62343": true,
      "62345": true,
      "62350": true,
      "62360": true,
      "62363": true,
      "62370": true,
      "62373": true,
      "62374": true,
      "62375": true,
      "62380": true,
      "62382": true,
      "62384": true,
      "62385": true,
      "62387": true,
      "62388": true,
      "62389": true,
      "62390": true,
      "62398": true,
      "62399": true,
      "62400": true,
      "62409": true,
      "62410": true,
      "62420": true,
      "62428": true,
      "62430": true,
      "62433": true,
      "62440": true,
      "62445": true,
      "62446": true,
      "62447": true,
      "62448": true,
      "62450": true,
      "62460": true,
      "62466": true,
      "62469": true,
      "62470": true,
      "62473": true,
      "62474": true,
      "62475": true,
      "62480": true,
      "62490": true,
      "62493": true,
      "62494": true,
      "62496": true,
      "62497": true,
      "62498": true,
      "62499": true
    },
    "Jiutepec": {
      "62550": true,
      "62553": true,
      "62554": true,
      "62555": true,
      "62556": true,
      "62560": true,
      "62563": true,
      "62564": true,
      "62565": true,
      "62566": true,
      "62570": true,
      "62573": true,
      "62574": true,
      "62575": true,
      "62576": true,
      "62577": true,
      "62578": true
    },
    "Temixco": {
      "62580": true,
      "62583": true,
      "62584": true,
      "62585": true,
      "62586": true,
      "62587": true,
      "62588": true,
      "62590": true,
      "62595": true,
      "62599": true
    },
    "Emiliano Zapata": {
      "62760": true,
      "62763": true,
      "62764": true,
      "62765": true,
      "62766": true,
      "62767": true
    },
    "Xochitepec": {
      "62790": true,
      "62795": true
    }
  },
  "Hidalgo": {
    "Mineral de la Reforma": {
      "42180": true,
      "42181": true,
      "42182": true,
      "42184": true,
      "42185": true,
      "42186": true,
      "42187": true
    },
    "Pachuca de Soto": {
      "42000": true,
      "42004": true,
      "42010": true,
      "42014": true,
      "42015": true,
      "42018": true,
      "42020": true,
      "42026": true,
      "42027": true,
      "42029": true,
      "42030": true,
      "42032": true,
      "42033": true,
      "42034": true,
      "42035": true,
      "42036": true,
      "42037": true,
      "42039": true,
      "42040": true,
      "42050": true,
      "42055": true,
      "42056": true,
      "42057": true,
      "42058": true,
      "42060": true,
      "42064": true,
      "42070": true,
      "42075": true,
      "42078": true,
      "42079": true,
      "42080": true,
      "42082": true,
      "42083": true,
      "42084": true,
      "42086": true,
      "42088": true,
      "42090": true,
      "42092": true,
      "42094": true,
      "42095": true,
      "42097": true,
      "42098": true,
      "42099": true,
      "42111": true
    }
  }
},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();

      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onCityChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onCityChange();
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
    _CUSTOM_COD_FORM_PROVINCES.onCityChange();
  },
  onCityChange: function () {
    var provValue = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
  }
};


function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
  } catch (e) {
    console.log(e);
  }
  _CUSTOM_COD_FORM_PROVINCES.startFields();
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_ZIP_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province_country_field";
      item.backendFields.elementType = "select";

      var options = [];

      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).forEach(key => {
        options.push({
          label: key,
          value: key
        })
      })


      item.backendFields.options = options;
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    } else if (item.type == "zip_code") {
      item.type = "zip_country_field";
      item.backendFields.name = "zip_code";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_ZIP_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_ZIP_LABEL) {
        _COD_FORM_ZIP_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_ZIP_LABEL
      }];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}